if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_pages_MyProfile_index_js-node_modules_pnpm_mui_icons-material_5_15_20__mui_material_5_15_-5065c4":1,"src_pages_Clients_index_js-node_modules_pnpm_mui_icons-material_5_15_20__mui_material_5_15_20-7e9e26":1,"src_pages_ContentManager_index_js":1,"src_pages_ContentManager_AccommodationsManager_AccommodationsEditor_index_js-node_modules_pnp-40fa0d":1,"src_pages_ContentManager_ServicesManager_ServicesEditor_index_js-node_modules_pnpm_tippy_js_6-3ff3e9":1,"src_components_Modals_ConfirmDenyModal_js-src_pages_ContentManager_CountriesManager_Countries-2b4585":1,"src_components_Modals_ConfirmDenyModal_js-src_pages_ContentManager_RegionsManager_RegionsEdit-05e528":1,"src_pages_ContentManager_RoomsManager_RoomsEditor_index_js-common_helpers_date-fns-format-shi-6b6ff7":1,"src_pages_MyAgents_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0__ty-fbcd28":1,"src_pages_Agencies_Agencies_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_ti-44ad23":1,"src_pages_Admin_BrandsManager_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js-26833e":1,"src_pages_MyAgency_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"vendors-node_modules_pnpm_mui_icons-material_5_15_20__mui_material_5_15_20__emotion_react_11_-442eed":1,"src_pages_Clients_ClientDetails_index_js-node_modules_pnpm_filepond_4_32_12_node_modules_file-0a7331":1,"src_api_queries_client_js-src_api_queries_edge_js-src_components_ItrvlAppBar_js-src_component-2e2e82":1,"src_pages_Login_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"src_pages_Chat_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"src_pages_Reports_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"src_pages_Edge_Catalog_index_js-node_modules_pnpm_slick-carousel_1_8_1_jquery_4_0_0_node_modu-4fdd9d":1,"src_pages_Insights_ClusterExplorer_index_js-node_modules_pnpm_lodash_4_17_21_node_modules_lod-e66cb4":1,"src_pages_Insights_ShapeMap_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_d-5bef2c":1,"src_pages_ItineraryBuilder_ItineraryBuilderEntry_js-node_modules_pnpm_slick-carousel_1_8_1_jq-951b21":1,"src_pages_EditItinerary_EditItineraryEntry_js-node_modules_pnpm_tanstack_react-query_4_44_0_r-65f0e6":1,"src_pages_PresentationEdit_index_js-common_helpers_date-fns-locale-en-US-shim_js-node_modules-807ce0":1,"src_pages_Edge_Detail_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0_-55621d":1,"vendors-node_modules_pnpm_video_js_7_21_7_node_modules_video_js_dist_video-js_css":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded